import {
  STEP_DESTINATION_EXPLORE_IRA,
  STEP_DESTINATION_EXPLORE_IRA_1,
  STEP_DESTINATION_EXPLORE_IRA_2,
  STEP_DESTINATION_EXPLORE_IRA_3,
  STEP_DESTINATION_EXPLORE_IRA_LOADING,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_BETTERMENT,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_FUTUREMONEY,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_ROBINHOOD,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_SOFI,
  STEP_DESTINATION_EXPLORE_IRA_OPTIONS,
  STEP_DESTINATION_EXPLORE_IRA_RESULT,
  STEP_DESTINATION_IRA_METHODOLOGY_SCREEN,
} from "../../class/transferDetails";
import ExploreIRAOptionLoading from "./screens/ExploreIRAOptionLoading";
import ExploreIRAOptionQuestionOne from "./screens/ExploreIRAOptionQuestionOne";
import ExploreIRAOptionQuestionThree from "./screens/ExploreIRAOptionQuestionThree";
import ExploreIRAOptionQuestionTwo from "./screens/ExploreIRAOptionQuestionTwo";
import ExploreIRAOptionResult from "./screens/ExploreIRAOptionResult";
import ExploreIRAOptions from "./screens/ExploreIRAOptions";
import IRAOptionIntroScreen from "./screens/IRAOptionIntroScreen";
import IRAPartnerScreen from "./screens/IRAPartnerScreen";
import MethodologyScreen from "./screens/MethodologyScreen";
import useExploreIRAOptions from "./useExploreIRAOptions";

const ExploreIRAOptionsScreen = () => {
  const props = useExploreIRAOptions();
  const { currentScreen, isLoading } = props;

  if (
    isLoading &&
    currentScreen !== STEP_DESTINATION_EXPLORE_IRA_LOADING &&
    currentScreen !== STEP_DESTINATION_IRA_METHODOLOGY_SCREEN
  ) {
    return <>Loading</>;
  }
  switch (currentScreen) {
    case STEP_DESTINATION_EXPLORE_IRA:
      return <IRAOptionIntroScreen {...props} />;
    case STEP_DESTINATION_EXPLORE_IRA_1:
      return <ExploreIRAOptionQuestionOne {...props} />;
    case STEP_DESTINATION_EXPLORE_IRA_2:
      return <ExploreIRAOptionQuestionTwo {...props} />;
    case STEP_DESTINATION_EXPLORE_IRA_3:
      return <ExploreIRAOptionQuestionThree {...props} />;
    case STEP_DESTINATION_EXPLORE_IRA_LOADING:
      return <ExploreIRAOptionLoading {...props} />;
    case STEP_DESTINATION_EXPLORE_IRA_RESULT:
      return <ExploreIRAOptionResult {...props} />;
    case STEP_DESTINATION_EXPLORE_IRA_OPTIONS:
      return <ExploreIRAOptions {...props} />;
    case STEP_DESTINATION_EXPLORE_IRA_OPTION_ROBINHOOD:
    case STEP_DESTINATION_EXPLORE_IRA_OPTION_FUTUREMONEY:
    case STEP_DESTINATION_EXPLORE_IRA_OPTION_BETTERMENT:
    case STEP_DESTINATION_EXPLORE_IRA_OPTION_SOFI:
      return <IRAPartnerScreen {...props} />;
    case STEP_DESTINATION_IRA_METHODOLOGY_SCREEN:
      return <MethodologyScreen {...props} />;

    default:
      return <></>;
  }
};

export default ExploreIRAOptionsScreen;
